/**
 * Phase HZ: CAMS 회사 로고 (Creative Auto Module System Co., Ltd.)
 *
 * 디자인:
 *  - 좌측: 파란색 원형 C + 안쪽 빨간 직사각형 배너 "AMS" 흰 글씨
 *  - 우측: "주식회사 캠스" 한글 + "Creative Auto Module System Co., Ltd." 영문
 *
 * variant:
 *  - 'icon': 로고 마크만 (헤더 좌상단, 모바일 헤더 등)
 *  - 'full': 마크 + 텍스트 (로그인, 푸터 등)
 *  - 'compact': 마크 + 짧은 텍스트 "CAMS"
 *
 * theme:
 *  - 'light': 흰 배경 — 회색 한글 텍스트
 *  - 'dark': 검정 배경 — 흰 한글 텍스트
 */

const COLORS = {
  blue: '#0052A4',
  red:  '#E60012',
  white: '#FFFFFF',
  gray:  '#374151',
};

export function CamsLogoMark({ size = 32, className = '' }) {
  // Phase IA: 실제 로고 PNG 파일 사용 (client/public/cams-icon.png)
  return (
    <img
      src="/cams-icon.png"
      alt="CAMS"
      width={size}
      height={size}
      className={className}
      style={{ objectFit: 'contain' }}
    />
  );
}

export default function CamsLogo({ variant = 'icon', theme = 'light', size = 32, className = '' }) {
  const textColor = theme === 'dark' ? COLORS.white : COLORS.gray;
  const subColor = theme === 'dark' ? '#9CA3AF' : '#6B7280';

  if (variant === 'icon') {
    return <CamsLogoMark size={size} className={className} />;
  }

  if (variant === 'compact') {
    return (
      <div className={`inline-flex items-center gap-2 ${className}`}>
        <CamsLogoMark size={size} />
        <span className="text-lg font-bold" style={{ color: textColor }}>CAMS</span>
      </div>
    );
  }

  // variant === 'full'
  return (
    <div className={`inline-flex items-center gap-3 ${className}`}>
      <CamsLogoMark size={size} />
      <div className="leading-tight">
        <h1 className="text-lg font-bold" style={{ color: textColor }}>주식회사 캠스</h1>
        <p className="text-[10px] tracking-tight" style={{ color: subColor }}>
          Creative Auto Module System Co., Ltd.
        </p>
      </div>
    </div>
  );
}
